import * as yup from "yup";

export const configsSchema = yup.object().shape({
  timezone: yup.string().required().default("").label("Timezone"),
  hour: yup.number().min(0).max(23).default("").label("Hour"),
  minute: yup.number().min(0).max(59).default("").label("Minute"),
  // terms_and_conditions: yup.string().label("Terms and Condition"),
});
